import { styled } from 'styled-components'

import { Colors } from '@b-stock/fe-core/design-system'

import { WatchlistTextButton } from './WatchlistTextButton'

// Matches the existing "View Watchlist" link's typography — fe-core's
// SnackbarContainer already styles a <button> inside toast body for this
// purpose (underline on hover), so this is the first toast in the app to
// actually render one instead of a Link. Color is BStock's brand blue tuned
// for a dark background (the toast's own background), per design. Shared by
// both the single-item and bulk watchlist-removal toasts.
export const WatchlistUndoButton = styled(WatchlistTextButton)`
  color: ${Colors.Semantic.BStock.default.darkBackground};
  white-space: nowrap;
`
